import * as React from "react"

import Home from "../components/update"
import Seo from "../components/seo"

const SpaPage = () => (
<Home>
<Seo title="Single Page app website react gatsby next remix svelte angular blazor wasm" />
<div className="container">
<div className="row mt-5">
<div className="col-md-6 p-3 p-md-5 mt-5 mb-5">
<h1><strong><a href="/spa/">Single Page App Website</a></strong></h1>
<h2>Single Page app website react gatsby next remix svelte angular blazor wasm</h2>
<p>Ingin memiliki situs yang modern teknologi maka menggunakan single page app adalah solusi tepat dalam mengembangkan website project, dengan pengalaman yang lebih berbeda dari kebanyakan situs pada umumnya, dengan penerapan konsep single page app ini maka temukan sensasi tanpa loading pada tiap akses halaman nya. Dan kita pun dapat menggunakan berbagai teknologi seperti react js, <a href="https://angular.io">angular</a>, svelte , maupun framework <a href="https://nextjs.org">next js</a>, gatsby js, remix , sveltekit, atau penggunaan microsoft technology dengan blazor webassembly.</p>
<ul className="nav nav-pills mb-3" id="pills-tab">
  <li className="nav-item p-1" role="presentation">
    <button className="btn btn-dark btn-sm active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">Demo 1</button>
  </li>
  <li className="nav-item p-1" role="presentation">
    <button className="btn btn-dark btn-sm" id="pills-demokasir-tab" data-bs-toggle="pill" data-bs-target="#pills-demokasir" type="button" role="tab" aria-controls="pills-demokasir" aria-selected="false">Demo 2</button>
  </li>
  <li className="nav-item p-1" role="presentation">
    <button className="btn btn-dark btn-sm" id="pills-hotel-tab" data-bs-toggle="pill" data-bs-target="#pills-hotel" type="button" role="tab" aria-controls="pills-hotel" aria-selected="false">Demo 3</button>
  </li>
 
</ul>
</div>
<div className="col-md-6 p-3 p-md-5 mt-5 mb-5">

<div className="tab-content" id="pills-tabContent">
  <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
<div className="ratio ratio-16x9">
  <iframe width="560" height="315" className="rounded" src="https://www.youtube.com/embed/VNIfcmP6Zwk" title="Pembuatan website terbaru gatsby js"></iframe>
</div>
  </div>
  <div className="tab-pane fade" id="pills-demokasir" role="tabpanel" aria-labelledby="pills-demokasir-tab">
  <div className="ratio ratio-16x9">
  <iframe width="560" height="315" className="rounded" src="https://www.youtube.com/embed/6l5Gcn98R2A" title="Pembuatan website single page app gatsby js, next js, react , angular,svelte kit"></iframe>
</div>
  </div>
  <div className="tab-pane fade" id="pills-hotel" role="tabpanel" aria-labelledby="pills-hotel-tab">
  <div className="ratio ratio-16x9">
  <iframe width="560" height="315" className="rounded" src="https://www.youtube.com/embed/hO9bvToni30" title="Pembuatan website next js remix gatsby js svelte kit blazor"></iframe>
</div>
  </div>

  </div>
  

</div>

</div>
</div>
</Home>
)

export default SpaPage